'use strict';

import _ from 'lodash';

export default function () {
    var _element = null;
    return {
        controller: function ($scope, $http, $sce, moment, $uibModal, $timeout) {
            'ngInject';

            $scope.item = null;

            $http({ url: '/api/newsitems/getnewshomespotlight', method: 'POST', data: {} })
                .then(function Success(result) {
                    $scope.item = result.data;
                });

            $scope.popup = function (item) {
                $uibModal.open({
                    templateUrl: 'NewsPopup',
                    size: 'sm',
                    windowClass: 'NewsPopup',
                    controller: function ($scope, $uibModalInstance) {
                        $scope.item = item;
                    }
                });
            };
            $scope.to_trusted = function (html_code) {
                return $sce.trustAsHtml(html_code);
            };
        },
        template: require('./newsHomeSpotlight.html'),
        link: function (scope, element, attrs) {
            _element = element;
        }
    };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/newsHomeSpotlight.js